var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expiredGhostCardMessage)?_c('div',{class:_vm.paddingClass},[_c('b-notification',{attrs:{"aria-close-label":"Close notification","type":_vm.type}},[_c('p',[_vm._v(" "+_vm._s(_vm.expiredGhostCardMessage)+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }